// extracted by mini-css-extract-plugin
export default {"wrap":"Qq-z","fullWidth":"Rq-z","items":"Sq-z","featureCss":"Tq-z","disabled":"Uq-z","imgCss":"Vq-z"};